const setupHandlerWithParam = function (paramName) {
  initContributionDetailsButton("data-entity-search-entity-id");
  $("a[data-selected-entity-id]").click(function (e) {
    $("#entity-search-modal").modal("hide");
    let entityId = $(this).attr("data-selected-entity-id");
    window.location.href =
      window.location.href + "?" + paramName + "=" + entityId;
    e.preventDefault();
  });
};

const setupFindKeepEntityHandler = function () {
  setupHandlerWithParam("keep_entity_id");
};

const setupFindMergeEntityHandler = function () {
  setupHandlerWithParam("merge_entity_id");
};

$(function () {
  $("#merge_entity_next_button").focus();
});

// Make functions globally available for inline scripts
window.setupFindKeepEntityHandler = setupFindKeepEntityHandler;
window.setupFindMergeEntityHandler = setupFindMergeEntityHandler;
